// extracted by mini-css-extract-plugin
export default {"prioriteTxt":"styles_prioriteTxt__mC8ZF","row":"styles_row__UF5LS","prioriteField":"styles_prioriteField__XAzsP","delayContainer":"styles_delayContainer__5ylXR"};